import { render, staticRenderFns } from "./CacheExtend.vue?vue&type=template&id=788b5edf"
import script from "./CacheExtend.vue?vue&type=script&lang=js"
export * from "./CacheExtend.vue?vue&type=script&lang=js"
import style0 from "./CacheExtend.vue?vue&type=style&index=0&id=788b5edf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports